export default function attachScript(src) {
  return new Promise(function (resolve) {
    const { body } = document;
    const script = document.createElement('script');
    script.src = src;

    let done = false;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true;

        resolve();

        script.onload = script.onreadystatechange = null;
        if (body && script.parentNode) {
          body.removeChild(script);
        }
      }
    };

    body.appendChild(script);
  });
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/attach-script.js